import '../faq-generator/stylesheets/main.scss'

import { registerHandlers } from '../faq-generator/scripts/event-handlers'

registerHandlers()
